// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__20q8r","footer":"ModalError_footer__2K9M4"};